import * as types from './constants';
import endpoints from '../../constants/endpoints';
import { getHttpInstance } from '../../services/defaultHttpService';
import { replaceTokensInString } from '../../utils';
import { CATCORP_ESITE_URL } from '@app/constants/commonConstants';

export const getFeatureFlags = () => async (dispatch, getState) => {
  const { storeId, esiteURL = CATCORP_ESITE_URL } = getState().common;
  const eSite = esiteURL.split('/').at(-1);

  const http = getHttpInstance();
  const hcl_url = replaceTokensInString(endpoints.STORE_FEATURE_FLAGS, storeId);
  const ld_url = replaceTokensInString(
    endpoints.LAUNCH_DARKLY_FEATURE_FLAGS,
    eSite
  );

  dispatch({ type: types.GET_FEATURE_FLAG_BEGIN });

  try {
    const HCL_PROMISE = http.get(hcl_url);
    const LD_PROMISE = http.get(ld_url);

    const [
      {
        data: { storefeatures: HCL_FEATURE_FLAGS = {} }
      },
      { data: LD_FEATURE_FLAGS = {} }
    ] = await Promise.all([HCL_PROMISE, LD_PROMISE]);

    const storeFeatures = {
      ...HCL_FEATURE_FLAGS,
      ...LD_FEATURE_FLAGS
    };

    dispatch({
      type: types.GET_FEATURE_FLAG_SUCCESS,
      payload: storeFeatures ?? {}
    });
  } catch (error) {
    dispatch({ type: types.GET_FEATURE_FLAG_FAIL });
  }
};
